import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { scopedCollection } from '../server/scoped-collection.js';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

export enum CertificateVariable {
  User_Vorname = 'User_Vorname',
  User_Nachname = 'User_Nachname',
  User_Geburtstag = 'User_Geburtstag',
  Produkt_Titel = 'Produkt_Titel',
  Produkt_Beschreibung_DE = 'Produkt_Beschreibung_DE',
  Produkt_Beschreibung_EN = 'Produkt_Beschreibung_EN',
  Zertifikat_Beschreibung_DE = 'Zertifikat_Beschreibung_DE',
  Zertifikat_Beschreibung_EN = 'Zertifikat_Beschreibung_EN',
  Termine_Datum_Uhrzeit = 'Termine_Datum_Uhrzeit',
  Termine_Datum_Uhrzeit_EN = 'Termine_Datum_Uhrzeit_EN',
  Termine_Datum = 'Termine_Datum',
  Erstellungs_Datum = 'Erstellungs_Datum',
  Zeitraum = 'Zeitraum',
  Startdatum = 'Startdatum',
  Enddatum = 'Enddatum',
}

@Entity()
export class Certificate extends MongoEntity {
  public static override _class = 'Certificate';
  public static override _collectionName = 'certificates';

  static get allFields() {
    return selectionSet(() => this, 3);
  }

  @Field(type => String)
  @validate(nonOptional())
  title!: string;

  @Field(type => Date, { default: v => v ?? new Date() })
  createdAt!: Date;

  @Field(type => String)
  @validate(nonOptional())
  text!: string;

  @Field(type => String)
  fileID!: string;

  @Field(type => AdornisFile, {
    resolve: function (this: Certificate) {
      return async gqlFields => (await scopedCollection(AdornisFile._class)).findOne<AdornisFile>({ _id: this.fileID });
    },
  })
  file: Maybe<AdornisFile>;

  @validate(nonOptional())
  @Field(type => String)
  public institutionID!: string;

  override toString() {
    return this.title ?? '';
  }
}
